import { Dialog, DialogTitle, DialogContent, LinearProgress, Typography, Box } from "@mui/material";
import AnimatedNumber from "components/AnimatedNumber";
import PropTypes from "prop-types";

function ImportProgressModal({ open, progress, message }) {
  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <DialogTitle>Importing Data...</DialogTitle>
      <DialogContent>
        <Box sx={{ py: 2 }}>
          <Typography variant="body2" sx={{ mb: 1 }}>
            {message || "Uploading..."}
          </Typography>
          <Box sx={{ width: "100%", mt: 1 }}>
            <Box
              sx={(theme) => ({
                height: 10,
                borderRadius: 5,
                backgroundColor: theme.palette.grey[300],
                overflow: "hidden",
              })}
            >
              <Box
                sx={(theme) => ({
                  height: "100%",
                  width: `${Math.max(0, Math.min(100, progress))}%`,
                  transition: "width 300ms ease",
                  backgroundColor: theme.palette.primary.main,
                })}
              />
            </Box>
            <Typography variant="caption" sx={{ mt: 1, display: "block", textAlign: "center" }}>
              <AnimatedNumber value={Math.round(progress)} suffix="%" duration={1} />
            </Typography>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

ImportProgressModal.propTypes = {
  open: PropTypes.func,
  progress: PropTypes.number,
  message: PropTypes.string,
};

export default ImportProgressModal;
